import { render, staticRenderFns } from "./update-data-picker.mpx?vue&type=template&id=65f8ad6b&isComponent&outputPath=components%2Fupdate-data-picker362397cc%2Findex"
import script from "./update-data-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fupdate-data-picker362397cc%2Findex"
export * from "./update-data-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fupdate-data-picker362397cc%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports